import { Search } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { cloneDeep, isEmpty, isString, pick } from 'lodash';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useGetAllCitiesQuery } from 'src/_api/mapitShipApi';
import OrderService from 'src/_services/orderService';

export default function ShortAddressCodeSearch({
    onChange,
    onLocationChange,
    values = [],
    shortAddress = "",
    ...props
}) {

    const { t } = useTranslation();
    const [nationalAddress, setNationalAddress] = useState('')
    const [loading, setLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [error, setError] = useState(null)
    const [validateNationalNumber, setValidateNationalNumber] = useState(null)


    const { data: cities, isLoading } = useGetAllCitiesQuery()

    //     {
    //     "city": "Aba Alworood",
    //     "details": "sdhfsfsd",
    //     "location": {
    //         "coordinates": [
    //             46.72969750128854,
    //             24.639169928308974
    //         ]
    //     },
    //     "street": "التخصصي الفرعي",
    //     "state": "الاسماعيليه",
    //     "area": "القوزين ",
    //     "buildingNumber": "44"
    // }

    useState(() => {
        if (!!shortAddress) {
            setNationalAddress(shortAddress)
        }
    }, [shortAddress])

    const getAddressFromNationalAddress = async () => {
        try {
            setIsSuccess(false)
            setError(null)
            setValidateNationalNumber(null)
            setLoading(true)

            const valid = /^[A-Z]{4}[0-9]{4}/.test(nationalAddress)
            if (!valid || nationalAddress.length !== 8) {
                setValidateNationalNumber('Please make sure you entered a valid national number')
                return
            }
            let response = await OrderService.getAddressFromNationalAddress({ nationalAddress })
            let data = cloneDeep(response.data.body)
            let address = data?.address

            const isArabic = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(address?.city ?? '')

            let city = isArabic ? '' : address?.city

            if (isArabic) {
                city = (cities ?? []).find((el) => el?.name_ar === address?.city)?.name_en ?? ""
            }

            let addr = {
                city: city,
                state: "",
                area: address?.area,
                street: address?.street,
                buildingNumber: address?.houseNumber,
                landmark: "",
                postcode: address?.postcode,
                shortAddress: nationalAddress
            }

            onChange({ target: { name: "address", value: isEmpty(values) ? addr : pick(addr, values) } })
            console.log({ target: { name: "address", value: isEmpty(values) ? addr : pick(addr, values) } });
            
            onLocationChange(data?.location.map(coord => Number(coord)))
        } catch (err) {
            let message = err?.response?.data?.message ?? 'Something went wrong please try again'
            setError(message)
        } finally {
            setLoading(false)
        }
    }
   

    return (
        <Box {...props}>
            <Grid container spacing={3} justifyContent="space-between">
                <Grid item xs={8} md={10}>
                    <TextField
                        fullWidth
                        label={t("Short Address Code")}
                        placeholder={t("Example (RRRR1234)")}
                        size="small"
                        name="nationalAddress"
                        value={nationalAddress}
                        onChange={(event) => setNationalAddress(event.target.value.toUpperCase())}
                        error={!!validateNationalNumber}
                        helperText={t(validateNationalNumber)}
                    />
                </Grid>
                <Grid item xs={4} md={2} sx={{ textAlign: "end" }}>
                    <LoadingButton endIcon={<Search />} onClick={getAddressFromNationalAddress} loading={loading} sx={{ textTransform: 'none' }} variant='contained'>
                        {t("Search")}
                    </LoadingButton>
                </Grid>
                {(isSuccess || error) &&
                    <Grid item xs={12}>
                        {isSuccess && <Typography color="green.main">{t("Done successfully")}</Typography>}
                        {!!error && <Typography color="error">{t(error)}</Typography>}
                    </Grid>
                }
            </Grid>
        </Box>
    )
}
